import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './bootstrap.scss';
import {AuthProvider} from "./hooks/useAuth";
import {ProfileProvider} from "./hooks/useProfile";
const authorizeEndpoint = process.env.REACT_APP_AUTHORIZE_ENDPOINT || "";
const tokenEndpoint = process.env.REACT_APP_TOKEN_ENDPOINT || "";
const redirectUri = process.env.REACT_APP_REDIRECT_URI || "";


ReactDOM.render(

    <BrowserRouter>
      <AuthProvider
        authorizeEndpoint={authorizeEndpoint}
        tokenEndpoint={tokenEndpoint}
        redirectUri={redirectUri}
        clientId={"1"}
        scope={"*"}
      >
        <ProfileProvider>
          <App/>
        </ProfileProvider>
      </AuthProvider>
    </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(Logger.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
